export default {
  path: '',
  name: 'reports',
  props: true,
  meta: { requiresAuth: true },
  component: () => import(/* webpackChunkName: "reports-types" */ './ReportTypes')
}
